import script from "./LessonStatsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonStatsPage.vue?vue&type=script&setup=true&lang=js"

import "./LessonStatsPage.vue?vue&type=style&index=0&id=a4ff08ac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ff08ac"]])

export default __exports__